import React, { useState } from "react";
import propertiesfaqData from "../../JsonData/propertiesFaqs.json";

const PropertiesFaqs = ({ propertyId }) => {
    const [isHovered, setIsHovered] = useState(false);
    let publicUrl = process.env.PUBLIC_URL + "/";
    let imagealt = "image";

    // 🔹 Correct property ka FAQ nikaalo
    const propertyFaq = propertiesfaqData?.propertiesfaqData?.find(
        (item) => item.Property_ID === String(propertyId)
    );

    // 🔹 Agar property ka FAQ hi nahi hai → kuch render mat karo
    if (!propertyFaq || !propertyFaq.faqs || propertyFaq.faqs.length === 0) {
        return null;
    }

    // 🔹 UI ke liye exact same structure
    const data = propertyFaq.faqs[0];

    return (
        <div className="faq-area pd-top-65 pd-bottom-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 mb-5 mb-lg-0">
                        <div className="section-title">
                            <h2
                                className="title"
                                dangerouslySetInnerHTML={{ __html: data.title }}
                            />
                            <p>{data.content}</p>
                        </div>

                        <div className="accordion" id="accordion">
                            {data.items.map((item, i) => (
                                <div key={i} className="single-accordion card">
                                    <div className="card-header" id={`headingOne${i}`}>
                                        <h2 className="mb-0">
                                            <button
                                                className="btn-link w-100 text-start"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target={`#collapseOne${i}`}
                                                aria-expanded="true"
                                                aria-controls={`collapseOne${i}`}
                                            >
                                                <span className="d-flex justify-content-between align-items-center w-100">
                                                    <span>{item.title}</span>

                                                </span>
                                            </button>

                                        </h2>
                                    </div>

                                    <div
                                        id={`collapseOne${i}`}
                                        className={`collapse ${item.class || ""}`}
                                        aria-labelledby={`headingOne${i}`}
                                        data-parent="#accordion"
                                    >
                                        <div className="card-body">{item.content}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* 🔹 Share Section (UNCHANGED) */}
                <div className="mt-4">
                    <p className="fw-semibold">
                        <strong>Share:</strong>
                    </p>

                    <ul className="social-icon d-flex align-items-center gap-3 list-unstyled p-0 m-0">
                        <li>
                            <a
                                href="https://www.facebook.com/profile.php?id=61574452610932"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fa fa-facebook" />
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://x.com/TrinestSky?t=0nIVrZfREEaavLFy1dJrQQ&s=09"
                                target="_blank"
                                rel="noopener noreferrer"
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                            >
                                <img
                                    src={
                                        isHovered ? "/twitterWhite.png" : "/icons8-x-50.png"
                                    }
                                    style={{ width: "15px", marginTop: "-5px" }}
                                    alt="X Logo"
                                />
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.linkedin.com/company/trinest-sky-real-estate/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fa fa-linkedin" />
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.instagram.com/trinestsky/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fa fa-instagram" />
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.youtube.com/channel/UCKrImHaqk4uHfAsHt9Ak4kg"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fa-brands fa-youtube" />
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.tiktok.com/@trinestsky?is_from_webapp=1&sender_device=pc"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fa-brands fa-tiktok" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default PropertiesFaqs;
